/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Success_Password_ResetInputs */

const en_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password reset email sent! Please check your inbox.`)
};

const fr_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email de réinitialisation du mot de passe envoyé ! Veuillez vérifier votre boîte de réception.`)
};

const de_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail zum Zurücksetzen des Passworts wurde versendet! Bitte überprüfen Sie Ihren Posteingang.`)
};

const it_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email di reimpostazione password inviata! Controlla la tua casella di posta.`)
};

const ru_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Письмо для сброса пароля отправлено! Пожалуйста, проверьте свою почту.`)
};

const es_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Correo electrónico de restablecimiento de contraseña enviado! Por favor, revise su bandeja de entrada.`)
};

const zh_cn2_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码重置邮件已发送！请查收您的邮箱。`)
};

const ja_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードリセットメールを送信しました。受信トレイをご確認ください。`)
};

const hi_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड रीसेट करने के लिए ईमेल भेजा गया है! कृपया अपना इनबॉक्स देखें।`)
};

const pt_pt2_login_success_password_reset = /** @type {(inputs: Login_Success_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail de redefinição de senha enviado! Por favor, verifique sua caixa de entrada.`)
};

/**
* | output |
* | --- |
* | "Password reset email sent! Please check your inbox." |
*
* @param {Login_Success_Password_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_success_password_reset = /** @type {((inputs?: Login_Success_Password_ResetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Success_Password_ResetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_success_password_reset(inputs)
	if (locale === "de") return de_login_success_password_reset(inputs)
	if (locale === "it") return it_login_success_password_reset(inputs)
	if (locale === "ru") return ru_login_success_password_reset(inputs)
	if (locale === "es") return es_login_success_password_reset(inputs)
	if (locale === "zh-CN") return zh_cn2_login_success_password_reset(inputs)
	if (locale === "ja") return ja_login_success_password_reset(inputs)
	if (locale === "hi") return hi_login_success_password_reset(inputs)
	if (locale === "pt-PT") return pt_pt2_login_success_password_reset(inputs)
	return en_login_success_password_reset(inputs)
});